import { useEffect } from 'react';

import { trackEvent } from 'integrations/metrics';

import {
  CoreFeaturesBackendData,
  CoreFeaturesProviderForSSR,
  ExperimentAssignmentReport,
} from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

function assignmentReporter(
  experimentAssignmentReport: ExperimentAssignmentReport,
) {
  trackEvent('Subject Assigned to AB Test' as any, {
    subject_type: experimentAssignmentReport.subjectType,
    subject_value: experimentAssignmentReport.subjectKey,
    experiment_name: experimentAssignmentReport.experimentKey,
    variant_name: experimentAssignmentReport.assignmentVariantName,
    variant_value: experimentAssignmentReport.assignmentValue,
  });
}

export function ConfiguredCoreFeaturesProvider({
  coreFeaturesBackendData,
  children,
}: {
  coreFeaturesBackendData?: CoreFeaturesBackendData;
  children: JSX.Element;
}): JSX.Element {
  const isBrowser = typeof window !== 'undefined';

  // Expose the RESOURCE_MANAGEMENT flag to non-React code (e.g. Redux thunks)
  useEffect(() => {
    if (isBrowser && coreFeaturesBackendData) {
      (window as any).__RESOURCE_MANAGEMENT_ENABLED__ = Boolean(
        coreFeaturesBackendData.featureFlagAssignments?.[
          FEATURE_FLAGS.RESOURCE_MANAGEMENT
        ],
      );
    }
  }, [coreFeaturesBackendData, isBrowser]);

  if (!coreFeaturesBackendData) {
    return children;
  }

  return (
    <CoreFeaturesProviderForSSR
      coreFeaturesBackendData={coreFeaturesBackendData}
      assignmentReporter={assignmentReporter}
    >
      {children}
    </CoreFeaturesProviderForSSR>
  );
}
